export const INITIAL = 'STATE_INITIAL';
export const REQUEST = 'STATE_REQUEST';
export const SUCCESS = 'STATE_SUCCESS';
export const FAILURE = 'STATE_FAILURE';
export const FETCH_GOODS_START = 'FETCH_GOODS_START';
export const FETCH_GOODS_SUCCESS = 'FETCH_GOODS_SUCCESS';
export const FETCH_GOODS_FAILURE = 'FETCH_GOODS_FAILURE';
export const FETCH_TRANSLATION_START = 'FETCH_TRANSLATION_START';
export const FETCH_TRANSLATION_SUCCESS = 'FETCH_TRANSLATION_SUCCESS';
export const FETCH_TRANSLATION_FAILURE = 'FETCH_TRANSLATION_FAILURE';
export const FETCH_CURRENT_ORDER_START = 'FETCH_CURRENT_ORDER_START';
export const FETCH_CURRENT_ORDER_SUCCESS = 'FETCH_CURRENT_ORDER_SUCCESS';
export const FETCH_CURRENT_ORDER_FAILURE = 'FETCH_CURRENT_ORDER_FAILURE';
export const TOGGLE_MODAL_ORDER = 'TOGGLE_MODAL_ORDER';
export const CHANGE_CURRENT_ORDER = 'CHANGE_CURRENT_ORDER';
export const SAVE_ORDER_START = 'SAVE_ORDER_START';
export const SAVE_ORDER_SUCCESS = 'SAVE_ORDER_SUCCESS';
export const SAVE_ORDER_FAILURE = 'SAVE_ORDER_FAILURE';
export const SET_ATTACHED_GOODS = 'SET_ATTACHED_GOODS';
export const SET_LAST_GOOD = 'SET_LAST_GOOD';
export const PRICE_REQUEST_MESSAGE_START = 'PRICE_REQUEST_MESSAGE_START';
export const PRICE_REQUEST_MESSAGE_SUCCESS = 'PRICE_REQUEST_MESSAGE_SUCCESS';
export const PRICE_REQUEST_MESSAGE_FAILURE = 'PRICE_REQUEST_MESSAGE_FAILURE';
